import axios from "axios";
import EventBus from "../EventBus";

// Any 401 from the API means the token is invalid/expired -> force logout.
let installed = false;
const setupInterceptors = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401 && localStorage.getItem("user")) {
        EventBus.dispatch("logout", { reason: "expired" });
      }
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
